<template>
  <div class="org-chart-wrapper">
    <a-row :gutter="[0, 0]" type="flex" class="main-row">
      <!-- Left: Organization Chart -->
      <a-col :xs="24" :lg="16" class="chart-col">
        <div class="org-container" ref="chartContainer"></div>
      </a-col>

      <!-- Right: Detail Panel -->
      <a-col :xs="24" :lg="8" class="detail-col">
        <transition name="fade-slide" mode="out-in">
          <div v-if="selectedNode" :key="selectedNode.id" class="detail-card-layout">
            <!-- Avatar Section (Left) -->
            <div class="avatar-col">
              <div class="avatar-wrapper">
                <img v-if="selectedNode.imageUrl" :src="selectedNode.imageUrl" class="large-avatar" />
                <div v-else class="avatar-placeholder">
                  <a-icon type="phone" />
                </div>
              </div>
              <div class="staff-id">
                <a-icon type="phone" class="id-icon" /> {{ selectedNode.id }}
              </div>
            </div>

            <!-- Content Section (Right) -->
            <div class="content-col">
              <h2 class="staff-name">{{ selectedNode.name }}</h2>
              <h3 class="staff-position">{{ selectedNode.positionName }}</h3>
              <ul v-if="selectedNode.responsibilities && selectedNode.responsibilities.length" class="resp-list">
                <li v-for="(resp, i) in selectedNode.responsibilities" :key="i">
                  <span class="bullet">•</span> {{ resp }}
                </li>
              </ul>
            </div>
          </div>

          <div v-else class="empty-detail">
            <a-empty description="Select a node to view details">
              <template #image>
                <img src="/images/hri_dashboard/dashboards.png" style="opacity: 0.5; width: 120px;" />
              </template>
            </a-empty>
          </div>
        </transition>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// ใช้ OrgChart ที่ vendor ไว้ในโปรเจกต์ (import ทุกอย่างจาก d3 v7 ตัวเดียว)
// แทน 'd3-org-chart' จาก node_modules ซึ่งตอน build production อาจได้ d3-selection คนละ copy
// กับที่ d3-transition patch ไว้ ทำให้เกิด "transition is not a function"
import { OrgChart } from '../lib/d3-org-chart';

export default {
  name: "OrganizationChart",
  data() {
    return {
      chart: null,
      selectedNode: null,
      staffData: [
        {
          id: '4435',
          name: 'ASST. PROF. DR.MALINVISA SAKDIYAKORN',
          positionName: 'Associate Dean for Human Resources',
          parentId: '',
          imageUrl: 'https://my.muic.io//media/staff_img/13000295_B11e0Jy.jpg',
          responsibilities: [
            'Ensures alignment of HR practices with college goals',
            'Provides guidance and overall direction for HR strategies and operations',
            'Supports policy development and facilitates communication with college staffs'
          ],
          isRoot: true
        },
        {
          id: '1299',
          name: 'MS.PIMLADA RUNGPATMETEEKUL',
          positionName: 'Interim Chief of Human Resources Section',
          parentId: '4435',
          imageUrl: 'https://my.muic.io//media/staff_img/13000061_final_2.jpg',
          responsibilities: [
            'Leads daily HR operations to deliver efficient and reliable services',
            'Strengthens coordination and teamwork across HR units',
            'Drives continuous improvement to enhance the HR experience for all staff'
          ]
        },
        {
          id: '1209',
          name: 'Human Resources Section',
          positionName: 'Organize Chart and Job Responsibilities',
          parentId: '4435',
          imageUrl: '',
          responsibilities: []
        },
        // HRM Branch
        {
          id: '1118',
          name: 'MS.YANIN SOMSRI',
          positionName: 'Head of Human Resource Management',
          parentId: '1209',
          imageUrl: 'https://my.muic.io//media/staff_img/13000478_lO8wjM7.jpg',
          responsibilities: ['Overall HRM Tasks', 'ERP & HRI Database', 'Provident Funds', 'Related Notifications'],
          branchLabel: ''
        },
        { id: '1119', name: 'MS.PITTAYARAT LA-ORNGNUAN', positionName: 'General Administration Assistant', parentId: '1118', imageUrl: 'https://my.muic.io//media/staff_img/13000747_gYWdSL6.jpg', responsibilities: ['Salary & OT', 'Tax', 'Social Security'] },
        { id: '1120', name: 'MR.SIRAWITH KEAWSOMBOON', positionName: 'Human Resources Officer', parentId: '1119', imageUrl: 'https://my.muic.io//media/staff_img/Retouch-DSC_91042.jpg', responsibilities: ['VISA & Work Permit', 'Leave of Absence', 'Recruitment'] },
        { id: '1121', name: 'MR.PHUDIS SANSERN', positionName: 'Human Resources Officer', parentId: '1120', imageUrl: 'https://my.muic.io//media/staff_img/13000884.jpg', responsibilities: ['Performance Appraisal', 'Contract Renewal', 'PD Appointment'] },

        // HRD Branch
        {
          id: '1230',
          name: 'MS.TASANEE SATEVONGSA',
          positionName: 'Interim Head of Human Resources Development Unit',
          parentId: '1209',
          imageUrl: 'https://my.muic.io//media/staff_img/13000465_cWXzvsK.jpg',
          responsibilities: ['Overall HRD Tasks', 'Development Activities', 'Related Notifications', 'Upskill & Reskill Scholarships', 'Professional Level Request (Supporting Staffs)', 'Career Path (Academic Staffs)', 'MU Global Talent Program'],
          branchLabel: ''
        },
        { id: '1512', name: 'MRS.PATTHARAT UATAWEESAMPHAN', positionName: 'Human Resources Officer', parentId: '1230', imageUrl: 'https://my.muic.io//media/staff_img/13000144_i7lx9Ft.jpg', responsibilities: ['HRD Budget', 'Development Activities', 'MU Global Talent', 'Related Notifications'] },
        { id: '1522', name: 'MS.SORAWEE PROMSOMBUT', positionName: 'Human Resources Officer', parentId: '1512', imageUrl: 'https://my.muic.io//media/staff_img/13000842_e6JIWWU.jpg', responsibilities: ['HRD Budget', 'Development Activities', 'Career Path (Supporting Staffs)'] },
        { id: '1122', name: 'Mr.Weeraphat Sangkaew', positionName: 'Human Resources Officer', parentId: '1522', imageUrl: 'https://my.muic.io//media/staff_img/13000929.jpg', responsibilities: ['Performance Appraisal', 'Contract Renewal', 'PD Appointment'] },
        // WELFARE Branch
        {
          id: '1612',
          name: 'MS.THIDARAT CHARUWAT',
          positionName: 'Head of Welfare and Benefits Unit',
          parentId: '1209',
          imageUrl: 'https://my.muic.io//media/staff_img/13000128_FANknNL_final.jpg',
          responsibilities: ['Overall Welfare Tasks', 'Welfare Benefits Activities', 'Related Notifications'],
          branchLabel: ''
        },
        { id: '1741', name: 'MRS.CHANITA NGAMKUNNATHAM', positionName: 'Human Resources Officer', parentId: '1612', imageUrl: 'https://my.muic.io//media/staff_img/13000035_FuFqe8N.jpg', responsibilities: ['Childbirth support benefit', 'Sickness support benefit', 'Funeral support', 'Welfare Activities'] },
        { id: '1742', name: 'MS.KANYAKON PENGJAROEN', positionName: 'Human Resources Officer', parentId: '1741', imageUrl: 'https://my.muic.io//media/staff_img/13000779.jpg', responsibilities: ['Group Insurance', 'Childbirth support benefit', 'Sickness support benefit', 'Funeral support', 'Welfare Activities'] },
      ]
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.$refs.chartContainer.innerHTML = '';
      this.chart = null;
    }
  },
  methods: {
    handleNodeSelect(nodeData) {
      if (!nodeData) return;

      // If nodeData is just ID, find from our staffData
      if (typeof nodeData === 'string') {
        this.selectedNode = this.staffData.find(s => s.id === nodeData) || null;
      } else if (nodeData.id) {
        // If it's a d3 node object or the raw data object
        const rawData = nodeData.data || nodeData;
        this.selectedNode = this.staffData.find(s => s.id === rawData.id) || rawData;
      }

      console.log('Successfully selected node:', this.selectedNode);
    },
    initChart() {
      const el = this.$refs.chartContainer;
      if (!el) return;

      if (el.clientWidth === 0 || el.clientHeight === 0) {
        setTimeout(() => this.initChart(), 100);
        return;
      }

      this.renderChart();
    },
    renderChart() {
      this.chart = new OrgChart()
        .container(this.$refs.chartContainer)
        .data(this.staffData)
        .nodeWidth(d => 450)
        .nodeHeight(d => 160)
        .childrenMargin(d => 60)
        .compactMarginBetween(d => 80)
        .compactMarginPair(d => 100)
        .compact(d => {
          return d.data.parentId === '1118' || d.data.parentId === '4353' || d.data.parentId === '1612';
        })
        .onNodeClick(d => {
          console.log('Node clicked:', d);
          // In some versions d is the nodeId, in others it is the node object.
          // d3-org-chart v2 usually passes the ID or the node.
          // If d is the node object, use d.data. 
          const nodeData = (d && d.data) ? d.data : d;
          this.handleNodeSelect(nodeData);
        })
        .buttonContent(({ node }) => {
          return `
            <div style="background-color: white; border: 1px solid #E4E2E9; border-radius: 4px; padding: 2px 8px; font-size: 10px; color: #716E7B; display: flex; align-items: center; justify-content: center; gap: 4px; border: 1px solid #d1d5db;">
              <span style="font-size: 9px;">${node.children ? '▲' : '▼'}</span> 
              <span>${node.data._directSubordinates || (node.children ? node.children.length : 0)}</span>
            </div>
          `;
        })
        .nodeContent((d) => {
          const branchLabelHtml = d.data.branchLabel
            ? `<div style="position: absolute; top: -70px; left: 10px; font-size: 80px; font-weight: 900; color: #F3F4F6; letter-spacing: 5px; z-index: 0; opacity: 0.8;">${d.data.branchLabel}</div>`
            : '';

          if (!d.data.imageUrl) {
            return `
              <div style="padding-top: 20px; height: 160px; width: 450px; position: relative; font-family: 'Inter', sans-serif; pointer-events: all;">
                ${branchLabelHtml}
                <div style="background-color: white; border: 1px solid #E5E7EB; border-radius: 12px; height: 130px; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 0 40px; box-sizing: border-box; position: relative; z-index: 100; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); cursor: pointer;">
                  <div style="font-size: 18px; font-weight: 800; color: #000000; margin-bottom: 4px; text-transform: uppercase; text-align: center; line-height: 1.2;">${d.data.name}</div>
                  <div style="font-size: 15px; font-weight: 700; color: #111827; text-align: center; line-height: 1.2;">${d.data.positionName}</div>
                </div>
              </div>
            `;
          }

          const responsibilitiesHtml = d.data.responsibilities
            ? d.data.responsibilities.map(r => `<li style="margin-bottom: 2px;">${r}</li>`).join('')
            : '';

          return `
            <div style="padding-top: 20px; height: 160px; width: 450px; position: relative; font-family: 'Inter', sans-serif; pointer-events: all;">
              ${branchLabelHtml}
              <div style="background-color: white; border: 1px solid #E5E7EB; border-radius: 12px; height: 130px; width: 100%; display: flex; align-items: center; padding: 0 20px; box-sizing: border-box; position: relative; z-index: 100; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); cursor: pointer;">
                <div style="display: flex; flex-direction: column; align-items: center; margin-right: 20px; min-width: 80px;">
                    <img src="${d.data.imageUrl}" style="border-radius: 50%; width: 70px; height: 70px; border: 2px solid #f3f4f6; object-fit: cover;" />
                    <div style="font-size: 10px; color: #6b7280; margin-top: 4px; display: flex; align-items: center; gap: 2px;">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        ${d.data.id}
                    </div>
                </div>

                <div style="flex: 1; text-align: left; overflow: hidden;">
                  <div style="font-size: 15px; font-weight: 800; color: #6D28D9; margin-bottom: 2px; text-transform: uppercase;">${d.data.name}</div>
                  <div style="font-size: 13px; font-weight: 700; color: #111827; margin-bottom: 6px;">${d.data.positionName}</div>
                  <ul style="font-size: 10px; color: #4b5563; padding-left: 14px; margin: 0; line-height: 1.2; font-style: italic;">
                    ${responsibilitiesHtml}
                  </ul>
                </div>
              </div>
            </div>
          `;
        })
        .render();

      setTimeout(() => {
        if (this.chart) {
          this.chart.expandAll().fit().centered(true);
          // Increase zoom by another 10% after fitting for a larger overview
          const { scale } = this.chart.getChartState();
          this.chart.scale(scale * 1.1).render();
        }
      }, 800);
    }
  }
};
</script>

<style scoped lang="scss">
.org-chart-wrapper {
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: #ffffff;
}

.main-row {
  height: 100%;
}

.chart-col {
  height: 100%;
  border-right: 1px solid #ffffff;
}

.org-container {
  width: 100%;
  height: 100%;
  min-height: 800px;
}

.detail-col {
  height: 100%;
  padding: 24px !important;
  background: #ffffff;
  overflow-y: auto;
}

/* Mobile & Tablet Responsiveness */
@media (max-width: 991px) {
  .main-row {
    height: auto;
    overflow-y: auto;
  }

  .chart-col {
    height: 500px;
    /* Sufficient height to interact with chart on mobile */
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
  }

  .org-container {
    min-height: 500px;
  }

  .detail-col {
    height: auto;
    min-height: 300px;
    padding: 40px 16px 24px !important;
    /* Increased top spacing for mobile */
    border-top: 1px solid #f0f0f0;
  }
}

.detail-card-layout {
  display: flex;
  align-items: flex-start;
  padding: 24px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  gap: 16px;
  min-height: 160px;
}

.avatar-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;

  .avatar-wrapper {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    padding: 3px;
    border: 2px solid #f3f4f6;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    margin-bottom: 8px;

    .large-avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }

    .avatar-placeholder {
      width: 100%;
      height: 100%;
      background: #f3f4f6;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #d1d5db;
    }
  }

  .staff-id {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 4px;

    .id-icon {
      font-size: 12px;
      color: #94a3b8;
    }
  }
}

.content-col {
  flex: 1;
  text-align: left;

  .staff-name {
    font-size: 17px;
    font-weight: 800;
    color: #6d28d9;
    margin-bottom: 1px;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .staff-position {
    font-size: 15px;
    font-weight: 800;
    color: #111827;
    margin-bottom: 12px;
    line-height: 1.2;
  }

  .resp-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 13px;
      color: #4b5563;
      margin-bottom: 3px;
      display: flex;
      align-items: flex-start;
      line-height: 1.4;
      font-style: italic;

      .bullet {
        margin-right: 6px;
        color: #4b5563;
        font-weight: bold;
        font-style: normal;
      }
    }
  }
}

@media (max-width: 576px) {
  .detail-card-layout {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    padding: 24px 16px;
  }


  .content-col {
    text-align: center;
  }

  .resp-list li {
    justify-content: center;
  }
}

.empty-detail {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fcfcfc;
  border: 2px dashed #f0f0f0;
  border-radius: 12px;
  min-height: 200px;
}

/* Animations */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateX(20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

::v-deep .node-rect {
  cursor: pointer;
}
</style>
